import React, { Component } from "react";
import { Icon, Layout, Menu } from "@tinper/next-ui";
import './style';
import { REFER_TYPE } from '../../utils/refer_context/referType';
import Table from './Table';
import Tree from './Tree';

const { Header, Content, Sider } = Layout;

export default class TreeTable extends Component {
    referContext = this.props.referContext;
    key = this.referContext.metaDataObj.cEntityKeyFld || 'id'; // 参照主键

    state = {
        isCollapsed: false, // 侧边栏是否收起
        searchKey: '', // 查询关键词
        selectedKeys: [], // 当前选中数据的id集合
        path: '' // 左树当前的路径值
    };

    componentDidMount () {}

    // 折叠左树
    onClickLeft = () => {
        this.setState({ isCollapsed: !this.state.isCollapsed });
    };

    // 触发响应式布局断点时的回调
    onBreakpoint = (broken) => {
        // console.log("broken", broken);
        this.setState({ isCollapsed: !broken });
    };

    // 左树更新所选值
    updateValue = (selectedList, dataSource) => {
        let selectedKeys = selectedList.map(item => item[this.key]);
        // let path = this.loop(dataSource, selectedKeys[0]);
        let path = selectedList[0].path
        if (selectedKeys[0] === 'all') {
            path = 'all'
        }
        this.setState({ selectedKeys, path });
    }

    // 根据所选id遍历查找对应的path
    // loop = (dataSource, selectedKey) => {
    //     let path = ''
    //     dataSource.forEach(item => {
    //         if (item[this.key] === selectedKey) {
    //             path = item.path;
    //         } else if (item.children && item.children.length > 0) {
    //             let _path = this.loop(item.children, selectedKey);
    //             if (_path) path = _path;
    //         }
    //     });
    //     return path;
    // }

    getFieldId = () => {
        const { fieldid, fieldidPrefix } = this.referContext.props || {};
        return fieldid || fieldidPrefix;
    };

    render () {
        const { isCollapsed, path, selectedKeys } = this.state;
        return (
            <Layout className="tree-table-layout-collapsed">
                <Layout>
                    <Sider
                        className="sider-container"
                        collapsible
                        collapsedWidth={0}
                        trigger={null}
                        collapsed={isCollapsed}
                        breakpoint="md"
                        onBreakpoint={this.onBreakpoint}
                        fieldid={`${this.getFieldId()}`}
                    >
                        <span
                            className='my-trigger'
                            style={{ left: isCollapsed ? 0 : 'unset' }}
                            onClick={this.onClickLeft}
                            fieldid={`${this.getFieldId()}_trigger`}
                        >
                            {!isCollapsed ? <Icon type="uf-triangle-left"/> : <Icon type="uf-triangle-right"/>}
                        </span>
                        <Tree
                            referContext={this.referContext}
                            metaData={this.props.metaData.tree}
                            topName={this.props.topName}
                            updateValue={this.updateValue}
                            isMultiple={false}
                            selectedTreeKeys={selectedKeys}
                        />
                    </Sider>
                    <Content style={{
                        minHeight: 340,
                        padding: "50px 10px 20px",
                        }}
                    >
                        <Table
                            referContext={this.referContext}
                            metaData={this.props.metaData.table}
                            path={path}
                            isMultiple={this.referContext.isMultiple}
                            newRefMeta={this.props.newRefMeta}
                        />
                    </Content>
                </Layout>
            </Layout>
        );
    }
}
